var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as usersData } from '@web/lib/demo/data/users';
import { mockData as workspacesData } from '@web/lib/demo/data/workspaces';
export var currentUser = function () {
    var user = usersData[0];
    var orgUnit = user.userOrgUnits[0].orgUnit;
    var userWithOrgUnit = __assign(__assign({}, user), { orgUnit: orgUnit });
    var workspace = workspacesData[0];
    return __assign(__assign({}, userWithOrgUnit), { workspace: workspace, orgUnit: orgUnit, isAdmin: true });
};
